function initHeroScroll(sectionId) {
  const section = document.getElementById(`hero-scroll-${sectionId}`);
  const video = document.getElementById(`hero-scroll-video-${sectionId}`);

  if (!section || !video) return;

  // Some mobile browsers (iOS Low Power Mode, Android data-saver) block
  // autoplay even with the autoplay/muted/playsinline attributes present,
  // and fall back to showing the native play button instead. Setting
  // `muted` as a JS property (not just the HTML attribute) satisfies a few
  // browsers that check it that way, and retrying play on the visitor's
  // first tap anywhere on the page silently starts it with no extra UI.
  video.muted = true;
  video.play().catch(() => {});

  function retryPlayOnInteraction() {
    if (video.paused) video.play().catch(() => {});
    document.removeEventListener('touchstart', retryPlayOnInteraction);
    document.removeEventListener('click', retryPlayOnInteraction);
  }
  document.addEventListener('touchstart', retryPlayOnInteraction, { once: true, passive: true });
  document.addEventListener('click', retryPlayOnInteraction, { once: true });

  // Pause the video once it's scrolled out of view so it isn't still decoding
  // frames in the background while the browser is trying to keep scrolling
  // smooth further down the page.
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    },
    { threshold: 0 }
  );
  observer.observe(section);
}
